import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon, FlameIcon, GiftIcon, ArrowRightIcon, TicketIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses, idealFor, offerIncludes } from '../data/system';
const trust = [{
  icon: LockIcon,
  label: '100% Güvenli Ödeme'
}, {
  icon: ZapIcon,
  label: 'Anında Erişim'
}, {
  icon: CreditCardIcon,
  label: 'Kredi / Banka Kartı'
}, {
  icon: SmartphoneIcon,
  label: 'Android ve iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Fiyat" className="scroll-mt-12 bg-obsidian text-white" data-id="element-196" data-mp="25s7up5qv6rzv">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-197" data-mp="25pv6wbyfdnew">
        <div className="mx-auto max-w-xl text-center" data-id="element-198" data-mp="3h6lg83y5avcq">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/40 bg-ember/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-ember" data-id="element-199" data-mp="3h9ha9h6vgzvw">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-200" data-mp="3vyx8e2sbu4gm" /> Sınırlı süreli teklif
          </p>
          
          
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden rounded-3xl border border-white/10 bg-navy shadow-[0_40px_80px_-40px_rgba(20,125,255,0.45)] lg:grid lg:grid-cols-[1fr_1.05fr]" data-id="element-201" data-mp="9s8r6yxnhi72">
          <div className="border-b border-white/10 p-6 sm:p-8 lg:border-b-0 lg:border-r" style={{
          paddingTop: "0px"
        }} data-id="element-202" data-mp="3n63r5ztbkv04">
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-203" data-mp="3rzy7qudmotuz">
              UZUN MESAFE TRİATLON SİSTEMİ™
            </h3>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-204" data-mp="2zgrc4jbb9spw">Kimler için uygundur?</p>
            <ul className="mt-3 space-y-2.5" data-id="element-205" data-mp="2rfjwvgg2gsno">
              {idealFor.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white/75" data-id="element-206" data-mp="2mibcrabcyejs">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-207" data-mp="3177lzap5hxlz" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="p-6 sm:p-8" data-id="element-208" data-mp="28hqucf9cukqt">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-209" data-mp="28is50imgl580">Fiyat</p>
            <div className="mt-2 flex flex-wrap items-end gap-x-3 gap-y-1" data-id="element-210" data-mp="23jz0hfp5gojz">
              <span className="font-display text-[72px] font-extrabold leading-[0.8]" data-id="element-211" data-mp="2igputajyva2q">1.330</span>
              <span className="pb-1 text-lg font-bold text-white/80" data-id="element-212" data-mp="2dgk888sk0dri">TRY</span>
              <span className="pb-1 text-xl font-medium text-white/35 line-through" data-id="element-213" data-mp="3tvbppqo5w0m1">2.673 TRY</span>
            </div>
            <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-214" data-mp="3ows4jshe6suq">Tek seferlik ödeme · Dijital erişim</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-215" data-mp="a44btg08ypz">Ödeme, yerel para biriminiz üzerinden gerçekleştirilecektir.</p>
            

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-216" data-mp="5b1i7ttzf6lo">
              Sistemin tamamında neler var?
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-217" data-mp="3rg56tdlwmk00">
              {offerIncludes.map(f => <li key={f} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-218" data-mp="j14y8329q42o">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-219" data-mp="o0hneugm3n8f" />
                  {f}
                </li>)}
            </ul>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-220" data-mp="a6qo0ewlhjqf">
              4 ücretsiz bonus
            </p>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-221" data-mp="11zhavyse1w30">
              {bonuses.map(b => <li key={b.n} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-222" data-mp="16qpjwtpt3ffn">
                  <span className="flex min-w-0 items-center gap-2 text-white/85" data-id="element-223" data-mp="3f7sa5uaju1t7">
                    <GiftIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-224" data-mp="3a7w840lewkga" />
                    <span className="truncate" data-id="element-225" data-mp="3592qbvz3e7ab">{b.title}</span>
                  </span>
                  <span className="whitespace-nowrap text-xs" data-id="element-226" data-mp="317r13rk4ro2n">
                    <span className="text-white/35 line-through" data-id="element-227" data-mp="319k7r6uqu8an">{b.price}</span>{' '}
                    <span className="font-bold text-perf" data-id="element-228" data-mp="1rawec1ebd9h">ÜCRETSİZ</span>
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-xl border border-perf/25 bg-perf/10 px-4 py-3" data-id="element-229" data-mp="3t19jyndfo061">
              <p className="flex items-center gap-2 text-sm font-semibold text-white" data-id="element-230" data-mp="3o63zlszoitk2">
                <ShieldCheckIcon className="h-5 w-5 shrink-0 text-perf" aria-hidden="true" data-id="element-231" data-mp="3k6d1t5bqjd61" />
                7 Günlük Para İade Garantisi
              </p>
              
            </div>

            <div className="mt-6" data-id="element-232" data-mp="fqu1sx2toai3">
              <CTAButton className="max-w-none" data-id="element-233" data-mp="fqkczctik9dz">Sisteme şimdi erişin</CTAButton>
            </div>
            <p className="mt-3 text-center text-xs font-semibold text-perf" data-id="element-234" data-mp="1yhhrfe3c22o7">
              1.343 TRY tasarruf edin · Sınırlı süreli teklif
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-235" data-mp="27f1tuqcxm50e">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-236" data-mp="2heiwt00su4so">
                  <Icon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-237" data-mp="2md3zr77fr2kt" />
                  {label}
                </li>)}
            </ul>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-ember" data-id="element-238" data-mp="2r53t2gt02x8f">
              <TicketIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-239" data-mp="2v44bvzbh9zvf" /> Teklif fiyatı: 1.330 TRY
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}